module.exports = __webpack_public_path__ + "static/media/coforge.30ddd725.jpg";